const Duty = () => import('Views/duty/index');

export default[
  { path: '/duty', component: Duty },
];



// WEBPACK FOOTER //
// ./src/router/duty.js